export enum PricingMode {
    Gross = 'Gross',
    Net = 'Net',
    Simple = 'Simple',
}
